// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Login Page */
.login-page {
  min-height: 100vh;
  background-color: #111827;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-card {
  width: 360px;
  background-color: #ffffff;
  border-radius: 10px;
  padding: 24px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.login-title {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 6px;
}

.login-subtitle {
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 20px;
}

.login-field {
  margin-bottom: 14px;
}

.login-label {
  display: block;
  font-size: 14px;
  margin-bottom: 6px;
  color: #374151;
}

.login-input {
  width: 100%;
  padding: 10px 12px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  font-size: 14px;
}

.login-input:focus {
  outline: none;
  border-color: #111827;
}

.login-button {
  width: 100%;
  padding: 12px;
  background-color: #111827;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
  margin-top: 8px;
}

.login-button:hover {
  background-color: #1f2937;
}

.login-footer {
  text-align: center;
  margin-top: 14px;
  font-size: 13px;
  color: #6b7280;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Authentication/style.css"],"names":[],"mappings":"AAAA,eAAe;AACf;EACE,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB","sourcesContent":["/* Login Page */\n.login-page {\n  min-height: 100vh;\n  background-color: #111827;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.login-card {\n  width: 360px;\n  background-color: #ffffff;\n  border-radius: 10px;\n  padding: 24px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n}\n\n.login-title {\n  font-size: 22px;\n  font-weight: bold;\n  margin-bottom: 6px;\n}\n\n.login-subtitle {\n  font-size: 14px;\n  color: #6b7280;\n  margin-bottom: 20px;\n}\n\n.login-field {\n  margin-bottom: 14px;\n}\n\n.login-label {\n  display: block;\n  font-size: 14px;\n  margin-bottom: 6px;\n  color: #374151;\n}\n\n.login-input {\n  width: 100%;\n  padding: 10px 12px;\n  border-radius: 6px;\n  border: 1px solid #d1d5db;\n  font-size: 14px;\n}\n\n.login-input:focus {\n  outline: none;\n  border-color: #111827;\n}\n\n.login-button {\n  width: 100%;\n  padding: 12px;\n  background-color: #111827;\n  color: #ffffff;\n  border: none;\n  border-radius: 6px;\n  font-size: 15px;\n  font-weight: bold;\n  cursor: pointer;\n  margin-top: 8px;\n}\n\n.login-button:hover {\n  background-color: #1f2937;\n}\n\n.login-footer {\n  text-align: center;\n  margin-top: 14px;\n  font-size: 13px;\n  color: #6b7280;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
